import { useState } from 'react';
import {InstyleButton} from '../components/Page/Page';
import {logService} from '../services/log.service';
import moment from 'moment';

export const ExportPath = "/exports";

export default function ExportPage(props) {
    const [exportDisabled, setDisabled] = useState(false);

    const handleExport = () => {
        if (exportDisabled) {
            return;
        }
        setDisabled(true);
        //post to the webserver which will respond with a file download
        logService.getDailyExport().then(res => {
            const date = moment().add(1, 'days').format('YYYY-MM-DD');
            var fileLink = document.createElement('a');
            fileLink.href = res;
            fileLink.download = `ConfirmedAppointments-${date}`;
            fileLink.click();
            setDisabled(false);
        })
    }

    return (
        <div style={{padding: '16px'}}>
            <div style={{width: '100%', display: 'flex', gap: '20px', alignItems: 'center'}}>
                <div>Export Tomorrow Confirmed Appts</div>
                <div><InstyleButton onClick={handleExport} disabled={exportDisabled}>Export to CSV</InstyleButton></div>
            </div>
        </div>
    )
}